import {
    // FILE_UPLOAD,
    CREATE_SJFROLES,
    RETRIEVE_SJFROLES,
    UPDATE_SJFROLES,
    DELETE_SJFROLES,
    RETRIEVESINGLE_SJFROLES,
} from "./type";
import SJFRoles from "../service/sjfRoles";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFRoles.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFRoles.create(data);
        dispatch({
            type: CREATE_SJFROLES,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFRoles.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFROLES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFRoles.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFROLES,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFRoles.update(data);
        dispatch({
            type: UPDATE_SJFROLES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFRoles.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFROLES,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFRoles.trash(data);
        dispatch({
            type: DELETE_SJFROLES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};